import { css } from '@emotion/core'

export default ({ theme }) => css`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: ${theme.zIndex.backdrop};
  border: 1px solid ${theme.colors.primary};
`
